import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { GoogleAuth, LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import mail from "../../assets/svg/message.svg";
import user from "../../assets/svg/user.svg";
import lock from "../../assets/svg/lock.svg";
import phone from "../../assets/svg/phone.png";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Input } from "antd";
import { ROUTES } from "../../settings/routes";
import {
	isEmpty,
	Toast,
	ValidateEmail,
	validatePhone,
} from "../../lib/helpers/helpers";
import { signup } from "../../redux/actions/authentication";
import { getAuth } from "../../redux/reducers/authReducer";

const SignupWrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const Signup = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const auth = useSelector(getAuth);
	const [loading, setLoading] = useState(false);
	const [fields, setFields] = useState({
		email: "",
		firstname: "",
		lastname: "",
		phone: "",
		password: "",
		newPassword: "",
	});
	const register = (e) => {
		e.preventDefault();
		const phone = validatePhone(fields.phone);

		if (isEmpty(fields.firstname.trim())) {
			Toast.fire({
				icon: "error",
				title: `Please input your firstname`,
			});
			return;
		}
		if (isEmpty(fields.lastname.trim())) {
			Toast.fire({
				icon: "warning",
				title: `Please input your lastname`,
			});
			return;
		}
		if (!ValidateEmail(fields.email.trim())) {
			Toast.fire({
				icon: "error",
				title: `You must enter a valid email address`,
			});
			return;
		}
		if (!phone) {
			Toast.fire({
				icon: "error",
				title: `Invalid phone number`,
			});
			return;
		}
		if (fields.password !== fields.newPassword) {
			Toast.fire({
				icon: "error",
				title: `Passwords do not match`,
			});
			return;
		}
		const data = {
			email: fields.email.trim(),
			firstname: fields.firstname.trim(),
			lastname: fields.lastname.trim(),
			phone: phone ? phone : "",
			password: fields.newPassword.trim(),
		};
		console.log(data);
		if (data.password.length < 2) {
			Toast.fire({
				icon: "error",
				title: `You must enter your password`,
			});
			return;
		}
		setLoading(true);
		dispatch(signup(data));
	};

	console.log(auth);

	useEffect(() => {
		try {
			if (!loading) {
				return;
			}
			setLoading(false);
			const { error, message, title, user } = auth;
			if (error) {
				Toast.fire({
					icon: "error",
					title: `${title}
					${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `Account created,
					Welcome to Wedding story, ${user?.firstname}`,
				});
				setTimeout(() => {
					history.push({
						pathname: ROUTES.VERIFICATION,
						state: { user },
					});
				}, 500);
			}
		} catch (error) {}
		// eslint-disable-next-line
	}, [auth]);

	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col! justify-center!">
				<SignupWrapper>
					<LandingTitle>
						Sign up to <br />
						Wedding Story💍
					</LandingTitle>

					<div tw="w-full pt-4">
						<form tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<Input
								placeholder="Your Firstname"
								type="text"
								value={fields.firstname}
								onChange={(e) =>
									setFields({
										...fields,
										firstname: e.target.value,
									})
								}
								css={inputStyle}
								prefix={
									<img
										src={user}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>
							<Input
								placeholder="Your Lastname"
								type="text"
								value={fields.lastname}
								onChange={(e) =>
									setFields({
										...fields,
										lastname: e.target.value,
									})
								}
								css={inputStyle}
								prefix={
									<img
										src={user}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>
							<Input
								placeholder="Your email"
								type="email"
								value={fields.email}
								onChange={(e) =>
									setFields({
										...fields,
										email: e.target.value,
									})
								}
								css={inputStyle}
								prefix={
									<img
										src={mail}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>
							<Input
								placeholder="Your phone number"
								type="number"
								value={fields.phone}
								onChange={(e) =>
									setFields({
										...fields,
										phone: e.target.value,
									})
								}
								css={inputStyle}
								prefix={
									<img
										src={phone}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>
							<Input.Password
								placeholder="Your password"
								type="password"
								value={fields.password}
								onChange={(e) =>
									setFields({
										...fields,
										password: e.target.value,
									})
								}
								css={inputStyle}
								prefix={<img src={lock} alt="" tw="pr-2" />}
								iconRender={(visible) =>
									visible ? (
										<EyeTwoTone />
									) : (
										<EyeInvisibleOutlined />
									)
								}
							/>
							<Input.Password
								placeholder="Confirm password"
								type="password"
								value={fields.newPassword}
								onChange={(e) =>
									setFields({
										...fields,
										newPassword: e.target.value,
									})
								}
								css={inputStyle}
								prefix={<img src={lock} alt="" tw="pr-2" />}
								iconRender={(visible) =>
									visible ? (
										<EyeTwoTone />
									) : (
										<EyeInvisibleOutlined />
									)
								}
							/>

							{/* <Link to={ROUTES.ACCOUNTSETUP} tw="mt-4 h-12">
								{" "} */}
							<button
								css={btnStyle}
								onClick={register}
								disabled={loading}>
								{loading ? <Loading /> : "Sign up"}
							</button>
							{/* </Link> */}

							<p tw="text-base text-appTextDark opacity-70 text-center mt-6 mb-6">
								or continue with
							</p>

							<div tw="w-full">
								<GoogleAuth />
							</div>

							<div>
								<p tw="text-center text-base font-medium mt-6">
									Already a member?{" "}
									<Link
										to={ROUTES.LOGIN}
										tw="text-appPink hover:(text-appPinkSaturated)">
										Log In
									</Link>
								</p>
							</div>
						</form>
					</div>
				</SignupWrapper>{" "}
			</div>
		</LandingLayout>
	);
};

export default Signup;
